export const socialsTypes = {
  instagram: 'https://instagram.com/',
  patreon: 'https://patreon.com/',
  reddit: 'https://reddit.com/u/',
  twitter: 'https://twitter.com/',
  facebook: 'https://facebook.com/',
  website: '',
  vk: 'https://vk.com/',
};
